import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { OrderRescheduled } from '../../../settings/account/profile/profile.types';

@Component({
    selector: 'app-rescheduled-orders',
  changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [],
    templateUrl: './rescheduled-orders.component.html',
    styleUrl: './rescheduled-orders.component.scss'
})
export class RescheduledOrdersComponent {
  orders: InputSignal<OrderRescheduled[] | undefined> = input();
}
